import Swiper from 'swiper';
import DeviceManager, { onPromiseAttrType } from '../utils/device-manager';

export default function initPostsCarousel() : void {
    const $postsCarousels = document.querySelectorAll<HTMLElement>('.js-posts-carousel');

    $postsCarousels.forEach($container => {
        new PostsCarousel($container);
    });
}

class PostsCarousel {
    $container: HTMLElement;
    swiper;
    initialized: boolean;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.initialized = false;

        DeviceManager.addCallback((attr: onPromiseAttrType) => {
            if (!this.initialized && DeviceManager.isLowerThan(attr.current, 'md')) {
                this.initialized = true;

                this.init();
            } else if (this.initialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                this.initialized = false;

                this.destroy();
            }
        });
    }

    /**
     * Initialize PostsCarousel
     * 
     * @return {void}
     */
    init() : void {
        this.swiper = new Swiper(this.$container, {
            loop: true,
            spaceBetween: 15,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    /**
     * Destroy PostsCarousel
     * 
     * @return {void}
     */
    destroy() : void {
        this.swiper.destroy();
    }
}
